import { skipToken } from "@reduxjs/toolkit/query";
import { createContext } from "react";
import { useParams } from "react-router-dom";
import { useGetSubscriptionByIdQuery } from "src/api/services/patientSubscriptionApi";
import { PatientSubscription } from "src/api/types";
import { MatchParam } from "src/constants/matches";

export const SubscriptionContext = createContext<PatientSubscription | null>(
  null,
);

interface Props {
  children: React.ReactNode;
}

const SubscriptionProvider = ({ children }: Props) => {
  const { subscriptionId } = useParams<MatchParam<"SUBSCRIPTION_ID">>();
  const { data: subscription } = useGetSubscriptionByIdQuery(
    subscriptionId ? Number(subscriptionId) : skipToken,
  );

  if (subscription == null) {
    return null;
  }

  return (
    <SubscriptionContext.Provider value={subscription}>
      {children}
    </SubscriptionContext.Provider>
  );
};

export default SubscriptionProvider;
